var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "z-not-found" }, [
    _c(
      "div",
      { staticClass: "z-not-found__description" },
      [
        !!this.$slots["description"]
          ? [_vm._t("description")]
          : [
              _c(
                "z-caption",
                { staticClass: "black-text", attrs: { size: "xl", tag: "h1" } },
                [
                  _vm.text
                    ? _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.text.title) },
                      })
                    : _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.textDefault.title) },
                      }),
                ]
              ),
              _vm._v(" "),
              _vm.text
                ? _c("p", {
                    staticClass: "z-not-found__tip",
                    domProps: { innerHTML: _vm._s(_vm.text.description) },
                  })
                : _c("p", {
                    staticClass: "z-not-found__tip",
                    domProps: {
                      innerHTML: _vm._s(_vm.textDefault.description),
                    },
                  }),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "z-not-found__image" },
      [_c("z-image", { attrs: { src: _vm.image } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }